import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import SiteContext from '@/context/SiteContext'

import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Botones from '@/components/BotonesHome'
import GlobalStyle from '@/styles/global.css'

const Layout = ({ clean = false, children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <SiteContext.Consumer>
      {theme => (
        <>
          <GlobalStyle />
          <div className={`themebg ${theme.dark ? 'dark' : 'light'}`}>
            {!clean && <Header siteTitle={data.site.siteMetadata.title} />}
            <main className="mt-20 ">{children}</main>
            <Botones />
            {!clean && <Footer />}
          </div>
        </>
      )}
    </SiteContext.Consumer>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
